export default __webpack_public_path__ + "static/char-s-35-ko-94c5ae6d5eeb63992ca3ac82944bd6a8.png";